import { styled, Box } from "@mui/material";

export const BackgroundMediaRoot = styled(Box)(() => ({
  position: "absolute",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: "auto",
  zIndex: 0,
}));

export const BackgroundDesktop = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "none",
  [theme.breakpoints.up("lg")]: {
    display: "block",
  },
  [theme.breakpoints.down("lg")]: {
    "@media (orientation: landscape)": {
      display: "block",
    },
  },
}));

export const BackgroundMobile = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "block",
  [theme.breakpoints.up("lg")]: {
    display: "none",
  },
  [theme.breakpoints.down("lg")]: {
    "@media (orientation: landscape)": {
      display: "none",
    },
  },
}));
